import { t } from 'i18next'
import { z } from 'zod'

import { Ticket } from './Ticket'
import { TicketEvaluation } from './TicketEvaluations'

export const TicketAttachmentType = z.enum(['FATHER', 'SON', 'GRANDSON'])
export type TicketAttachmentType = z.infer<typeof TicketAttachmentType>

export const TicketDetails = Ticket.extend({
  evaluated: TicketEvaluation.nullable(),
  family: z.array(
    Ticket.extend({
      id: Ticket.shape.id.nullable(),
      attachment: z.object({
        id: z.string().nullable(),
        attachmentType: TicketAttachmentType
      })
    })
  )
})
export type TicketDetails = z.infer<typeof TicketDetails>

export const TicketDetailsDTO = z.object({
  personaId: z.string().min(1, t('general.form.required'))
})
export type TicketDetailsDTO = z.infer<typeof TicketDetailsDTO>
